import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const BaseTag = (props) => (
  <Box
    className={props.className}
    sx={{ alignContent: "center", alignItems: "center", display: "flex" }}
  >
    {props.icon && (
      <Box sx={{ paddingRight: "5px", height: "24px" }}>{props.icon}</Box>
    )}
    <Box className="Label" sx={{ flexGrow: 1 }}>
      {props.label}
    </Box>
  </Box>
);

export default styled(BaseTag)(
  ({ theme }) => `
  font-family: milliard-light;

  .Label {
    height: 24px;
  }`,
);
